var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgX(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 26,
    rx: 13,
    fill: "#D33444"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.2336 10.037C17.585 9.68562 17.585 9.11495 17.2336 8.76355C16.8822 8.41215 16.3116 8.41215 15.9602 8.76355L13 11.7265L10.037 8.76636C9.68562 8.41496 9.11495 8.41496 8.76355 8.76636C8.41215 9.11776 8.41215 9.68843 8.76355 10.0398L11.7265 13L8.76636 15.963C8.41496 16.3144 8.41496 16.8851 8.76636 17.2365C9.11776 17.5878 9.68843 17.5878 10.0398 17.2365L13 14.2735L15.963 17.2336C16.3144 17.585 16.8851 17.585 17.2365 17.2336C17.5878 16.8822 17.5878 16.3116 17.2365 15.9602L14.2735 13L17.2336 10.037Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgX);
export default __webpack_public_path__ + "static/media/x.43db05dfa56e3f51ba9b24815a819f44.svg";
export { ForwardRef as ReactComponent };